@if (isActivitiesTabVisible) {
  <div>
    <div class="be-attributes-container mb-4 flex items-center justify-between">
      <div>
        <ng-select
          [(ngModel)]="activitiesTabComponent.selectedVendor"
          bindLabel="label"
          bindValue="id"
          [disabled]="true"
          [items]="activitiesTabComponent.vendors"
          class="[&_.ng-input]:hidden"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              #label
              class="cursor-not-allowed truncate before:absolute before:inset-0 before:content-['']"
              [auxTooltip]="label.offsetWidth < label.scrollWidth ? item.label : ''"
            >
              {{ item.label }}
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div>
        <aux-button
          variant="tertiary"
          (clickEmit)="activitiesTabComponent.addNewRow()"
          icon="Plus"
          label="Add New Activity"
        />
      </div>
    </div>
  </div>
}

@if (!isActivitiesTabVisible) {
  <div>
    <div class="be-attributes-container mb-4 flex items-center justify-between">
      <div>
        <ng-select
          [(ngModel)]="attributesTabComponent.selectedVendor"
          bindLabel="label"
          bindValue="id"
          [disabled]="true"
          [items]="attributesTabComponent.vendors"
          class="[&_.ng-input]:hidden"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              #label
              class="cursor-not-allowed truncate before:absolute before:inset-0 before:content-['']"
              [auxTooltip]="label.offsetWidth < label.scrollWidth ? item.label : ''"
            >
              {{ item.label }}
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div>
        <aux-button
          variant="secondary"
          (clickEmit)="attributesTabComponent.addNewColumn()"
          icon="Plus"
          label="Add New Attribute"
          classList="!border-none h-[35px]"
          [disabled]="attributesTabComponent.addNewColumnDisabled"
          [auxTooltip]="attributesTabComponent.data?.notEditableAttributesTooltip || ''"
        />
      </div>
    </div>
  </div>
}

<div
  class="be-attributes-container relative w-[1220px]"
  [ngClass]="{
    'max-h-[524px]': showNotesSection,
    'h-[524px]': showNotesSection,
    'overflow-y-auto': showNotesSection,
  }"
>
  <aux-activities-tab
    #activitiesTabComponent
    class="block"
    [ngClass]="{
      'invisible h-0 overflow-hidden': !isActivitiesTabVisible,
    }"
    [gridData$]="gridData$"
    [data]="ref.data"
    [hasExternalChanges]="attributesTabComponent.isAttributesTabHasChanges()"
    (toggleTabs)="toggleToAttributesTab($event)"
    (save)="saveFromActivitiesTab($event)"
    (closeTab)="close()"
    [inAppDocumentState]="inAppDocumentState()"
    [showNotesSection]="showNotesSection"
  />
  <aux-attributes-tab
    #attributesTabComponent
    class="block"
    [ngClass]="{
      'invisible h-0 overflow-hidden': isActivitiesTabVisible,
    }"
    [gridData$]="gridData$"
    [data]="ref.data"
    [categories]="categories"
    [hasExternalChanges]="activitiesTabComponent.isActivitiesTabHasChanges()"
    (toggleTabs)="toggleToActivitiesTab($event)"
    (save)="saveFromAttributesTab($event)"
    (closeTab)="close()"
    [inAppDocumentState]="inAppDocumentState()"
    [showNotesSection]="showNotesSection"
  />
  @if (showNotesSection) {
    <div class="w-[1200px]">
      <ng-container *ngTemplateOutlet="InAppNotesAndDocuments"></ng-container>
    </div>
  }
</div>

<ng-template #InAppNotesAndDocuments>
  <div class="grid h-60 w-[1200px] grid-cols-3">
    <div class="col-span-2 mr-8 flex flex-col items-start justify-start space-y-3">
      <div class="flex items-center justify-start space-x-1">
        <aux-icon [name]="'Message'" />
        <span class="font-bold">
          <span class="mr-1">Notes</span>
          <span class="text-aux-error">*</span>
        </span>
      </div>
      <aux-input
        id="notes"
        class="w-full pl-1 text-xs"
        placeholder="Enter notes here..."
        validators="required"
        [inAppBudgetStyle]="true"
        [textArea]="true"
        resize="none"
        [errMessage]="'Notes*'"
        [(ngModel)]="notes"
        (ngModelChange)="noteChange(notes)"
      />
    </div>
    <div class="col-span-1 flex w-full flex-col space-y-3">
      <div class="flex flex-row items-center justify-start space-x-2">
        <span class="font-bold">Supporting Documents</span>
        <span class="italic">(optional)</span>
      </div>
      <div class="w-full">
        <aux-file-manager
          #manager
          class="h-32"
          [fetchFilesOnInit]="false"
          [eager]="false"
          [pathFn]="getFilePath()"
          [metadataFn]="getMetadata()"
        />
        <div class="mt-4 max-h-[42px] overflow-y-auto">
          <aux-file-viewer
            [fileManager]="manager"
            [disableFirstFileMargin]="true"
            [onlyShowUploaded]="false"
            [type]="'inAppBudget'"
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>
